import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '../event-bus.js';

import { QBtn, QToolbar, QToolbarTitle } from 'quasar';
import MultipanelDockLayout from './vuecontrols/MultipanelDockLayout.vue';
import {
    MultipanelDockPanel,
    MultipanelDockZone,
    MultipanelDockTabGroup,
} from './vuecontrols/MultipanelDockLayout/index.js';

import utils from '../../Shared/utils.jsx';

export default defineComponent({
    name: 'dock-layout',
    mixins: [BaseComponent],
    components: {
        QToolbar,
        QToolbarTitle,
        QBtn,
        MultipanelDockLayout,
        MultipanelDockPanel,
        MultipanelDockZone,
        MultipanelDockTabGroup,
    },
    data: function () {
        return {
            layout: null,
        };
    },
    created() {
        //    for (let i = 0; i < this.controlData.Panes.length; i++) {
        //        const p = this.controlData.Panes[i];
        //        if (p.DisplayExpression)
        //            p.displayexpr = utils.compileExpression(this, p.DisplayExpression);
        //    }
    },
    //Created Replaced with preRenderComplete
    computed: {
        totalItems() {
            let count = 1;
            //if (this.controlData.Panes && Array.isArray(this.controlData.Panes))
            //    for (let p of this.controlData.Panes)
            //        count += p.Controls.length;

            return count;
        },
        storageKey: function () {
            //if (this.persistencekeyexpn) {
            //    const key = utils.evaluate(this.persistencekeyexpn, this);
            //    return `splitpanes-${this.parentType}-${key || this.controlData.Name || 'unnamed'}-${this.controlData.$objectid || 'noid'}`;
            //}
            //else
            return `docklayout-${this.parentType}-${this.controlData.Name || 'unnamed'}-${this.controlData.$objectid || 'noid'}`;
        },
        styles() {
            let styles = {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            };

            if (this.controlData?.SizeOptions?.Height?.Mode === 'Auto' || this.controlData?.SizeOptions?.Height?.Mode === 'Fill')
                styles.minHeight = '100px';

            if (this.controlData?.SizeOptions?.Width?.Mode === 'Auto' || this.controlData?.SizeOptions?.Width?.Mode === 'Fill')
                styles.minWidth = '200px';

            return styles;
        },
    },
    methods: {
        loadPersistedLayout() {
            try {
                const raw = localStorage.getItem(this.storageKey);
                if (!raw)
                    return null;
                return JSON.parse(raw);
            }
            catch (_) {
                return null;
            }
        },
        persistLayout(layoutJson = null) {
            try {
                const serialized = layoutJson ?? this.$refs.dockRef?.serializeLayout?.();
                if (!serialized)
                    return;
                localStorage.setItem(this.storageKey, JSON.stringify(serialized));
            }
            catch (_) {
                // Ignore storage failures in test harness mode.
            }
        },
        async preRenderComplete() {
            this.finishRenderHandler(this);
        },
        logLayout() {
            console.log(JSON.stringify(this.$refs.dockRef?.serializeLayout?.()));
        },
        reset() {
            this.$refs.dockRef?.resetLayout?.();
            try {
                localStorage.removeItem(this.storageKey);
            }
            catch (_) {
                // Ignore storage failures in test harness mode.
            }
        },
        onLayoutChange(layoutJson) {
            this.persistLayout(layoutJson);
        },
    },
    mounted() {
        this.layout = this.loadPersistedLayout();
    },
    render() {
        if (!this.todisplay)
            return null;

        try {
            return (
                <div style={{ ...this.styles, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                    class={{ 'c-DockLayout': true, [`c-name-${this.name || 'unnamed'}`]: true }}>
                    <QToolbar class="bg-primary text-white">
                        <QToolbarTitle>MultipanelDockLayout demo</QToolbarTitle>
                        <QBtn flat dense label="Serialize" onClick={this.logLayout} />
                        <QBtn flat dense label="Reset" onClick={this.reset} />
                    </QToolbar>
                    <MultipanelDockLayout
                        ref="dockRef"
                        layout={this.layout}
                        onUpdate:layout={(v) => this.layout = v}
                        class="col"
                        onLayoutChange={this.onLayoutChange}
                    >
                        <MultipanelDockPanel id="explorer" title="Explorer" icon="mdi-folder-outline" panelKind="tool" defaultZone="left" disallowedZones={['center']}>
                            <div class="q-pa-md">Explorer content</div>
                        </MultipanelDockPanel>

                        <MultipanelDockPanel id="editor" title="Editor" icon="mdi-code-tags" panelKind="center" defaultZone="center" pinned={true} allowedZones={['center']}>
                            <div class="q-pa-md">Editor content (unpinned — blurs to collapse)</div>
                        </MultipanelDockPanel>

                        <MultipanelDockZone zone="bottom" layout="split" orientation="horizontal" sizes={[0.55, 0.45]}>
                            <MultipanelDockPanel id="console" title="Console" icon="mdi-console" panelKind="tool" defaultZone="bottom" disallowedZones={['center']}>
                                <div class="q-pa-md">Console output</div>
                            </MultipanelDockPanel>
                            <MultipanelDockPanel id="locals" title="Locals" icon="mdi-variable-box" panelKind="tool" defaultZone="bottom" disallowedZones={['center']}>
                                <div class="q-pa-md">Locals</div>
                            </MultipanelDockPanel>
                        </MultipanelDockZone>

                        <MultipanelDockZone zone="right" layout="split" orientation="vertical" sizes={[0.55, 0.45]}>
                            <MultipanelDockTabGroup tab-placement="bottom">
                                <MultipanelDockPanel id="properties" title="Properties" icon="mdi-tune" panelKind="tool" disallowedZones={['center']}>
                                    <div class="q-pa-md">Properties content</div>
                                </MultipanelDockPanel>
                                <MultipanelDockPanel id="variables" title="Variables" icon="mdi-variable" panelKind="tool" disallowedZones={['center']}>
                                    <div class="q-pa-md">Variables content</div>
                                </MultipanelDockPanel>
                            </MultipanelDockTabGroup>
                            <MultipanelDockTabGroup tab-placement="bottom">
                                <MultipanelDockPanel id="watch" title="Watch" icon="mdi-eye-outline" panelKind="tool" disallowedZones={['center']}>
                                    <div class="q-pa-md">Watch content</div>
                                </MultipanelDockPanel>
                                <MultipanelDockPanel id="breakpoints" title="Breakpoints" icon="mdi-debug-step-over" panelKind="tool" disallowedZones={['center']}>
                                    <div class="q-pa-md">Breakpoints content</div>
                                </MultipanelDockPanel>
                            </MultipanelDockTabGroup>
                        </MultipanelDockZone>

                    </MultipanelDockLayout >
                </div >
            );
        }
        catch (e) {
            utils.error('DockLayout Render failed', e);
            return <div>DockLayout Failed to Render {e}</div>;
        }
    }
});
